import { Action, Task } from "../types";
import { toTaskDTO, fromTaskDTO, fromTaskDTOCreate } from "../dto/taskDTO";
import axiosConnector from "./axiosConnector";
import { API_URL } from './axiosConnector';

export const getTasks = async (): Promise<Task[]> => {
  try {
    const response = await axiosConnector.get<Task[]>("/tasks");
    return response.data.map(toTaskDTO);
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const updateTask = async (task: Task): Promise<void> => {
  console.log("task", task);
  console.log("fromTaskDTO(task)", fromTaskDTO(task));
  try {
    await axiosConnector.patch(`/tasks/${task.id}`, fromTaskDTO(task));
    
  } catch (error) {
    console.error(error);
  }
};

export const deleteTask = async (task: Task): Promise<void> => {
  try {
    await axiosConnector.remove(`/tasks/${task.id}`);
  } catch (error) {
    console.error(error);
  }
};

interface CreateTaskResponse {
  id: number;
}

export const createTask = async (task: Task): Promise<CreateTaskResponse|undefined> => {
  try {
    const response = await axiosConnector.post<CreateTaskResponse>('/tasks', fromTaskDTOCreate(task));
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getActionList = async (): Promise<Action[]> => {
  try {
    const actionsResponse = await axiosConnector.get<Action[]>(`${API_URL}/tasks/available-actions`);

    const actions = actionsResponse.data;
    return actions;
  } catch (error) {
    console.error(error);
    return [];
  }
};